export const isAnswersMultiple = (question: any) => {
  if (!question) {
    return false;
  }

  return question.answers.filter((answer: any) => answer.correct).length > 1;
};

export const isAnswersCorrect = ({
  questions,
  currentAnswers,
  currentQuestionIndex,
}: {
  questions: any;
  currentAnswers: any;
  currentQuestionIndex: any;
}) => {
  const currentQuestion = questions[currentQuestionIndex];

  if (!currentQuestion) {
    return false;
  }

  const correctAnswers = currentQuestion.answers.filter(
    (answer: any) => answer.correct,
  );

  const correct =
    correctAnswers.every((answer: any) => currentAnswers.includes(answer.id)) &&
    currentAnswers.length <= correctAnswers.length;

  return correct;
};

const shuffleArray = (array: any) => {
  const shuffledArray = [...array];
  for (let i = shuffledArray.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [shuffledArray[i], shuffledArray[j]] = [shuffledArray[j], shuffledArray[i]];
  }
  return shuffledArray;
};

export const randomizeLessonAnswers = (less: any) => {
  return {
    ...less,
    questions: less.questions.map((question: any) => {
      return { ...question, answers: shuffleArray(question.answers) };
    }),
  };
};

export const isAswersEmpty = (question: any) => {
  return (question.answers.length === 0 || question.answersType === '') && true;
};
